function InfoCard(props) {

  const cardContent = getCardContent();

  function getCardContent() {   
    let title = 'Info';
    let content = <div><p>Hover the mouse over any label to find out more info.</p></div>;

    switch (props.id) {
      case 'authCodeFlow':
        title = 'Authorization Code Flow';
        content = <div><p>The <b>Authorization Code Flow</b> is an OAuth 2 grant type used by confidential and public clients to exchange an authorization code 
                    for an access token, and involves the user to grant permission via a web browser.
                    It is recommended that all clients use the PKCE extension with this flow to provide better security.</p></div>
        break;
      case 'clientCredFlow':
        title = 'Client Credentials Flow';
        content = <div><p>The <b>Client Credentials Flow</b> is an OAuth 2 grant type used by system clients (such as backend services)
                    to obtain an access token where there is no user involved.</p></div>
        break;
      case 'authServerMD':
        title = 'Authorization Server Metadata';
        content = <div><p>The <b>Authorization Server Metadata</b> contains the authorization server metadata information, 
                    such as endpoint locations and references to key stores required to validate (token) signatures.</p></div>
        break;
      case 'wellKnownUri':
        title = 'Well Known URI';
        content = <div><p>The <b>well-known URI</b> uses the well-known path prefix defined as /.well-known/.
                    It allows for discovery of the authorization server metadata, including all necessary endpoints and public key information.</p></div>
        break;
      case 'authorizeUri':
        title = 'Authorize URI';
        content = <div><p>The <b>authorize URI</b> is the the authorization server endpoint where the OAuth 2 flow starts and the
                    authorization code is issued, that will need to be exchanged for an access token.</p></div>
        break;
      case 'tokenUri':
        title = 'Token URI';
        content = <div><p>The <b>token URI</b> is the the authorization server endpoint for retrieving OAuth 2 access tokens.</p></div>
        break;
      case 'redirectUri':
        title = 'Redirect URI';
        content = <div><p>The <b>redirect URI</b> tells the authorization server where to redirect the browser back 
                    after the user grants permission to the application. Because the redirect URL will contain sensitive information,
                    it needs to be registered with the authorization server.</p></div>
        break;
      case 'clientId':
        title = 'Client ID';
        content = <div><p>Every client application (website or mobile app) is identified by a <b>client ID</b>, that needs to be registered 
                    with the authorization server. Unlike a client secret, the client ID is a public value that does not have to be protected.</p></div>
        break;
      case 'clientType':
        title = 'Client Types';
        content = <div><p><b>Confidential clients</b> are applications that run on servers (e.g. web apps, web APIs, or service/daemon apps).
                      They have the ability to safely keep an application secret.</p>
                      <p>In contrast, <b>public clients</b> are applications that run on devices or in a web browser without a backend server (e.g. SPAs). 
                      They do not have the ability to safely keep an application secret.</p></div>
        break;
      case 'clientSecret':
        title = 'Client Secret';
        content = <div><p> The <b>client secret</b> is used by the OAuth 2 client to authenticate to the authorization server and to prevent client impersonation. 
                    The client secret is known only to the OAuth 2 Client and the Authorization Server. </p></div>
        break;
      case 'scopes':
        title = 'Scope';
        content = <div><p>The <b>scopes</b> hold the information to which resources a client is requesting access to.
                    There can be multiple scopes specified separated by spaces.</p></div>
        break;
      case 'code':
        title = 'Authorization Code';
        content = <div><p>The <b>authorization code</b> is a temporary code issued by the authorization server, that the client will exchange for an access token.</p></div>
        break;
      case 'token':
        title = 'Access Token';
        content = <div><p>The <b>access token</b> represents the authorization granted to an application (client) to access resources on behalf of the end-user.</p></div>
        break;
      case 'pkce':
        title = 'PKCE';
        content = <div><p><b>PKCE</b> (or <b>Proof Key for Code Exchange</b>) is an extension to the Authorization Code flow to prevent CSRF (Cross Site Request Forgery) and code injection attacks.</p></div>
        break;
      case 'codeVerifier':
        title = 'Code Verifier';
        content = <div><p>The <b>code verifier</b> is a cryptographically random string that is used by the PKCE mechanism.
                    The client is generating the code verifies, and uses it to create the code challenge.
                    Subsequently, the client must present the code verifier to the authorization server, when exchanging the authorization code for an access token.</p></div>
        break;
      case 'codeChallenge':
        title = 'Code Challenge';
        content = <div><p>The <b>code challenge</b> is a BASE64-URL-encoded string of the code verifier hash. 
                  The recommended hashing algorithm is SHA-256.</p></div>
        break;
      case 'codeChallengeMethod':
        title = 'Code Challenge Method';
        content = <div><p>The <b>code challenge method</b> is computation logic that was used to compute the value of the code challenge.
                    The recommended cryptographic hash function is SHA-256.</p></div>
        break;
      case 'state':
        title = 'State';
        content = <div><p>The <b>state</b> is an optional value that is is a unique, randomly generated, opaque, and non-guessable string 
                        that is sent when starting an authorization request and validated when processing the response.
                        They are used primarily to prevent CSRF attacks.</p></div>
        break;  
      case 'nonce':
          title = 'Nonce';
          content = <div><p>The <b>nonce</b> (or <b>n</b>umber used <b>once</b>) is a random value that is used to prevent replay attacks.</p></div>
          break;
  
        default:
          // 
      }
    return {title: title, content: content};    
  }

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title">
          <i aria-hidden="true" className="fa fa-info-circle "></i>
          <strong className="card-header-text">{cardContent.title}</strong>
        </h5>
      </div>
      <div className="card-body text-center">
        <div className="card-text">
        {cardContent.content}
        </div>
      </div>
    </div>
  )

}

export default InfoCard;